import { format, isValid, parse } from 'date-fns';

import { EDateFormats } from 'common/config/constants/date-formats';

const convertSecondsToShow = (seconds: number) => {
  if (seconds >= 3600 * 24) {
    const days = Math.trunc(seconds / (3600 * 24));
    return { time: days, unit: days === 1 ? 'day' : 'days' };
  }

  if (seconds >= 3600) {
    const hours = Math.trunc(seconds / 3600);
    return { time: hours, unit: hours === 1 ? 'hour' : 'hours' };
  }

  if (seconds >= 60) {
    const minutes = Math.trunc(seconds / 60);
    return { time: minutes, unit: minutes === 1 ? 'minute' : 'minutes' };
  }

  return { time: seconds, unit: seconds === 1 ? 'second' : 'seconds' };
};

const returnDatePattern = (date?: string) => {
  const enumValues: EDateFormats[] = Object.values(EDateFormats);

  if (date) {
    for (const value of enumValues) {
      const parsedDate = parse(date, value, new Date());
      if (isValid(parsedDate)) {
        return value;
      }
    }
  }

  return (date || '') as EDateFormats;
};

const formatDateTo = (inputDate: string | undefined, toFormat: EDateFormats) => {
  const datePattern = returnDatePattern(inputDate);

  if (inputDate && datePattern) {
    const parsedDate = parse(inputDate, datePattern, new Date());
    const formattedDate = format(parsedDate, toFormat);

    return formattedDate;
  }
  return inputDate;
};

const validateExpirationDate = (date: string, format: EDateFormats) => {
  if (format === EDateFormats.MM_yyyy) {
    const validDateFormat = isValid(parse(date, EDateFormats.MM_yyyy, new Date()));

    const today = new Date();

    if (date) {
      const dateArray = date.split('/');
      const dateInformed = new Date(Number(dateArray[1]), Number(dateArray[0]));
      const isNotExpired =
        dateInformed.getTime() >= new Date(today.getFullYear(), today.getMonth() + 1).getTime();
      return isNotExpired && validDateFormat;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export { convertSecondsToShow, formatDateTo, validateExpirationDate };
